/** Decimales al mostrar cantidades y avance. Ausente o distinto de 4 significa 2. */
export function quantityDisplayDecimals(project) {
  const configs = project && project.configs
  const value = configs && configs.quantity_display_decimals

  return Number(value) === 4 ? 4 : 2
}

/** Etiqueta de una cantidad o un porcentaje de avance. No usar para dinero ni horas. */
export function formatProjectFigure(value, project) {
  const number = Number(value)
  if (!Number.isFinite(number)) {
    return ''
  }

  return number.toFixed(quantityDisplayDecimals(project))
}
